<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      widgetInterval: null,
    };
  },
  mounted() {
    if (this.$route.meta.requiresAuth) {
      this.loadAgentWidget();
      this.startWidgetInterval();
    }
  },
  beforeDestroy() {
    this.stopWidgetInterval();
  },
  watch: {
    '$route'(to) {
      if (to.meta.requiresAuth) {
        this.loadAgentWidget();
        this.startWidgetInterval();
      } else {
        this.removeAgentWidget();
        this.stopWidgetInterval();
      }
    },
  },
  methods: {
    startWidgetInterval() {
      if (this.widgetInterval) return;
      this.widgetInterval = setInterval(() => {
        this.refreshAgentWidget();
      }, 10000);
    },
    stopWidgetInterval() {
      if (this.widgetInterval) {
        clearInterval(this.widgetInterval);
        this.widgetInterval = null;
      }
    },
    refreshAgentWidget() {
      const rawToken = window.localStorage.getItem('jwtToken');
      const token = rawToken ? rawToken.replace('Bearer ', '') : null;
      if (!token) return;
      const existingScript = document.getElementById('agent-widget-script');
      if (!existingScript) {
        this.loadAgentWidget();
      } else if (window.AssistantWidget && window.AssistantWidget.updateToken) {
        window.AssistantWidget.updateToken(token);
      }
    },
    loadAgentWidget() {
      if (document.getElementById('agent-widget-script')) return;
      const rawToken = window.localStorage.getItem('jwtToken');
      const token = rawToken ? rawToken.replace('Bearer ', '') : null;
      if (!token) return;
      const agentUrlMap = {
        'localhost': 'http://localhost:4502',
        '127.0.0.1': 'http://localhost:4502',
        'flux': 'http://localhost:4502',
        'dev-partner-portal.app.fairown.tech': 'https://assistant-staging.up.railway.app',
      };
      const agentUrl = agentUrlMap[window.location.hostname] || 'https://agent.teenusliising.ee';
      const script = document.createElement('script');
      script.id = 'agent-widget-script';
      script.src = `${agentUrl}/widget.js`;
      script.dataset.apiUrl = agentUrl;
      script.dataset.authToken = token;
      document.body.appendChild(script);
    },
    removeAgentWidget() {
      if (window.AssistantWidget) {
        window.AssistantWidget.destroy();
      }
      const script = document.getElementById('agent-widget-script');
      if (script) script.remove();
    },
  },
};
</script>

<style></style>
